import { useParams } from 'react-router-dom';
import { checkPermission } from '../helpers/permissionHelper';
import { giveProfile } from '../Components/global-notification/notification-list';
import OrgWiseConfigHelper from '../helpers/OrgWiseConfigHelper';

// Note this is not a custom hook as the name wrongly represents, as it doesn't have any React specific logic
const usePermissionTabs = () => {
  const { companyId, relation } = useParams();
  const isForwarder = giveProfile(relation) === 'forwarder';
  const isSupplier = giveProfile(relation) === 'supplier';
  const isBuyer = giveProfile(relation) === 'buyer';
  const isCustomBroker = giveProfile(relation) === 'customBroker';
  const isForwarderCustomer = giveProfile(relation) === 'forwarderCustomer';

  const docPermissions = [
    ['My Company', 'Remove Documents'],
    ['My Company', 'Remove Documents', 'V'],
    ['My Company', 'Manage Documents'],
    ['My Company', 'Manage Documents', 'V'],
    ['My Supplier', 'Manage Documents'],
    ['My Supplier', 'Manage Documents', 'V'],
  ];

  const MyEntitiesPermissions = [
    ['My Entities', 'Ask Quotation'],
    ['My Entities', 'Ask Quotation', 'V'],
    ['My Entities', 'Add/Edit'],
    ['My Entities', 'Add/Edit', 'V'],
  ];

  const performancePermissions = [
    ['My Company', 'View Review'],
    ['My Company', 'View Review', 'V'],
    ['My Supplier', 'Manage Review'],
    ['My Supplier', 'Manage Review', 'V'],
  ];
  const vendorPermissions = [
    ['My Company', 'Manage Vendor'],
    ['My Company', 'Manage Vendor', 'V'],
    ['My Supplier', 'View Vendors'],
    ['My Supplier', 'View Vendors', 'V'],
  ];

  const productPermissionsTabs = [
    ['My Company', 'Manage Product'],
    ['My Company', 'Manage Product', 'V'],
    ['My Supplier', 'View Products'],
    ['My Supplier', 'View Products', 'V'],
  ];

  const locationPermissionsTabs = [
    ['My Company', 'Manage Locations'],
    ['My Company', 'Manage Locations', 'V'],
    ['My Supplier', 'View Location'],
    ['My Supplier', 'View Location', 'V'],
  ];

  const timelinePermissionTabs = [
    ['Order', 'Macro Timeline Visibility'],
    ['Order', 'Macro Timeline Visibility', 'V'],
    ['Order', 'Micro Timeline Visibility'],
    ['Order', 'Micro Timeline Visibility', 'V'],
  ];

  const displayOrderDetailsDocTab = [
    ['Order', 'Manage Documents'],
    ['Order', 'Manage Documents', 'V'],
    ['Order', 'Remove Documents', 'V'],
    ['Order', 'Document_Accept'],
    ['Order', 'Document_request'],
    ['Order', 'Document_request', 'V'],
  ];

  const supplierActPerm = [
    ['Supplier Role', 'createCargoRequest'],
    ['Supplier Role', 'Milestone update'],
    ['Supplier Role', 'ChangeRequest'],
  ];

  const CustomEntries = [
    ['Booking', 'createBooking'],
    ['Booking', 'QuotationReject'],
    ['Booking', 'QuotationAccept'],
    ['Booking', 'Remove Documents'],
    ['Booking', 'Manage Documents'],
    ['Booking', 'contractedBooking'],
    ['Booking', 'Add User'],
    ['Booking', 'Remove User'],
    ['Booking', 'Document_request'],
    ['Booking', 'Document_Reject'],
    ['Booking', 'Document_Accept'],
    ['Booking', 'Quotation Exception Approvals'],
  ];
  const ConsolidatedBooking = [
    ['Booking', 'createBooking'],
    ['Booking', 'QuotationReject'],
    ['Booking', 'QuotationAccept'],
    ['Booking', 'Remove Documents'],
    ['Booking', 'Manage Documents'],
    ['Booking', 'contractedBooking'],
    ['Booking', 'Add User'],
    ['Booking', 'Remove User'],
    ['Booking', 'Document_request'],
    ['Booking', 'Document_Reject'],
    ['Booking', 'Document_Accept'],
    ['Booking', 'Quotation Exception Approvals'],
  ];
  const ConsolidatedShipment = [
    ['Shipment', 'Custom broker Approval'],
    ['Shipment', 'Manage Documents'],
    ['Shipment', 'Remove Documents'],
    ['Shipment', 'Schedule Pick-up'],
    ['Shipment', 'Request Delivery Entry from CSC'],
    ['Shipment', 'R1 Request'],
    ['Shipment', 'Remove User'],
    ['Shipment', 'Add User'],
    ['Shipment', 'Document_request'],
    ['Shipment', 'Document_Reject'],
    ['Shipment', 'Document_Accept'],
    ['Shipment', 'Approval of additional Funds'],
    ['Shipment', 'Insufficient Fund Notification'],
  ];

  const customsListing = [
    ['Booking', 'createBooking'],
    ['Booking', 'QuotationReject'],
    ['Booking', 'QuotationAccept'],
    ['Booking', 'Remove Documents'],
    ['Booking', 'Manage Documents'],
    ['Booking', 'contractedBooking'],
    ['Booking', 'Add User'],
    ['Booking', 'Remove User'],
    ['Booking', 'Document_request'],
    ['Booking', 'Document_Reject'],
    ['Booking', 'Document_Accept'],
    ['Booking', 'Quotation Exception Approvals'],
    ['Shipment', 'Custom broker Approval'],
    ['Shipment', 'Manage Documents'],
    ['Shipment', 'Remove Documents'],
    ['Shipment', 'Schedule Pick-up'],
    ['Shipment', 'Request Delivery Entry from CSC'],
    ['Shipment', 'R1 Request'],
    ['Shipment', 'Remove User'],
    ['Shipment', 'Add User'],
    ['Shipment', 'Document_request'],
    ['Shipment', 'Document_Reject'],
    ['Shipment', 'Document_Accept'],
    ['Shipment', 'Approval of additional Funds'],
    ['Shipment', 'Insufficient Fund Notification'],
  ];
  const hideCustomsMenu = customsListing.some((permission) =>
    checkPermission(giveProfile(relation), ...permission)
  );

  const hideCustomEntries = CustomEntries.some((permission) =>
    checkPermission(giveProfile(relation), ...permission)
  );

  const hideConsolidatedBooking = ConsolidatedBooking.some((permission) =>
    checkPermission(giveProfile(relation), ...permission)
  );

  const hideConsolidatedShipment =
    isBuyer &&
    ConsolidatedShipment.some((permission) =>
      checkPermission(giveProfile(relation), ...permission)
    );
  const hideMySuppliersTab =
    isBuyer &&
    supplierActPerm.some((permission) =>
      checkPermission(giveProfile(relation), ...permission)
    );

  const displayTimelineTab =
    isBuyer &&
    timelinePermissionTabs.some((permission) =>
      checkPermission(giveProfile(relation), ...permission)
    );

  const displayMyEntitiesTab =
    (isSupplier ||
      isForwarder ||
      isBuyer ||
      isCustomBroker ||
      isForwarderCustomer) &&
    MyEntitiesPermissions.slice(0, 4).some((permission) =>
      checkPermission(giveProfile(relation), ...permission)
    );

  const displayDocTab =
    ((isSupplier ||
      isForwarder ||
      isBuyer ||
      isCustomBroker ||
      isForwarderCustomer) &&
      !companyId &&
      docPermissions
        .slice(0, 4)
        .some((permission) =>
          checkPermission(giveProfile(relation), ...permission)
        )) ||
    (giveProfile(relation) === 'buyer' &&
      companyId &&
      docPermissions
        .slice(-2)
        .some((permission) =>
          checkPermission(giveProfile(relation), ...permission)
        ));

  const displayPerformTab =
    ((isSupplier || isBuyer) &&
      performancePermissions
        .slice(0, 2)
        .some((permission) =>
          checkPermission(giveProfile(relation), ...permission)
        )) ||
    (isBuyer &&
      companyId &&
      performancePermissions
        .slice(2)
        .some((permission) =>
          checkPermission(giveProfile(relation), ...permission)
        ));

  const displayVendorTab =
    ((isSupplier || isBuyer) &&
      vendorPermissions
        .slice(0, 2)
        .some((permission) =>
          checkPermission(giveProfile(relation), ...permission)
        )) ||
    (isBuyer &&
      companyId &&
      vendorPermissions
        .slice(2)
        .some((permission) =>
          checkPermission(giveProfile(relation), ...permission)
        ));

  const displayProductTab =
    ((isSupplier || isBuyer) &&
      productPermissionsTabs
        .slice(0, 2)
        .some((permission) =>
          checkPermission(giveProfile(relation), ...permission)
        )) ||
    (isBuyer &&
      companyId &&
      productPermissionsTabs
        .slice(2)
        .some((permission) =>
          checkPermission(giveProfile(relation), ...permission)
        ));

  const displayLocationTab =
    ((isSupplier ||
      isForwarder ||
      isBuyer ||
      isCustomBroker ||
      isForwarderCustomer) &&
      locationPermissionsTabs
        .slice(0, 2)
        .some((permission) =>
          checkPermission(giveProfile(relation), ...permission)
        )) ||
    (isBuyer &&
      companyId &&
      locationPermissionsTabs
        .slice(2)
        .some((permission) =>
          checkPermission(giveProfile(relation), ...permission)
        ));

  const DisplaySystemIntregation = checkPermission(
    giveProfile(relation),
    'Configuration',
    'configure Webhook'
  );
  const DisplayApiDocument =
    checkPermission(
      giveProfile(relation),
      'Configuration',
      'API Documentation'
    ) ||
    checkPermission(
      giveProfile(relation),
      'Configuration',
      'API Documentation',
      'V'
    );
  const DisplayOrderDetailsDocTab = displayOrderDetailsDocTab.some((perm) =>
    checkPermission(giveProfile(relation), ...perm)
  );
  const DisplayBookingDetailsDocTab =
    checkPermission(giveProfile(relation), 'Booking', 'Manage Documents') ||
    checkPermission(
      giveProfile(relation),
      'Booking',
      'Manage Documents',
      'V'
    ) ||
    checkPermission(giveProfile(relation), 'Booking', 'Remove Documents') ||
    checkPermission(giveProfile(relation), 'Booking', 'Remove Documents', 'V');
  const displayR1flag = checkPermission(
    giveProfile(relation),
    'Shipment',
    'R1 Request'
  );

  const displayshippingcarbonEmission =
    OrgWiseConfigHelper('shipment')?.carbonEmission;
  const displayshippingdemerageDetention =
    OrgWiseConfigHelper('shipment')?.demerageDetention;
  const displayshippingcustomVisibility =
    OrgWiseConfigHelper('shipment')?.customVisibility;

  const toggleDirectShipmentPer = checkPermission(
    giveProfile(relation),
    'Shipment',
    'External Vendor Shipment'
  );

  const toggleVendorPackagePer = checkPermission(
    giveProfile(relation),
    'Shipment',
    'External Vendor Shipment'
  );
  return {
    displayTimelineTab,
    displayMyEntitiesTab,
    displayDocTab,
    displayPerformTab,
    displayVendorTab,
    displayProductTab,
    displayLocationTab,
    DisplaySystemIntregation,
    DisplayApiDocument,
    DisplayOrderDetailsDocTab,
    DisplayBookingDetailsDocTab,
    displayshippingcarbonEmission,
    displayshippingdemerageDetention,
    displayshippingcustomVisibility,
    displayR1flag,
    hideMySuppliersTab,
    hideCustomEntries,
    hideConsolidatedBooking,
    hideConsolidatedShipment,
    hideCustomsMenu,
    toggleDirectShipmentPer,
    toggleVendorPackagePer,
  };
};

export default usePermissionTabs;
